import api from "../../../api/axios";

// Read-only global Task list transport.
// GET /api/crm/tasks/ — party-scoped queryset (assignee OR creator).

export const fetchTasks = (params = {}, { signal } = {}) =>
  api
    .get("/crm/tasks/", { params, signal })
    .then((res) => res.data);

export const fetchClientSummary = (clientId, { signal } = {}) =>
  api
    .get(`/crm/clients/${clientId}/`, { signal })
    .then((res) => res.data);
